import * as React from 'react';

import { SvgIconProps } from '@material-ui/core';
import {
  classNameForCallOut,
  classNameForCallOutContent,
  classNameForCallOutToggle,
} from '../utils/CallOutUtils';
import BaseComponent from './BaseComponent';
import LinkButton from './buttons/LinkButton';

export type Variant =
  | 'subtle'
  | 'default'
  | 'negative'
  | 'positive'
  | 'warning'
  | 'internal'
  | 'invisible';

export interface ICallOut {
  children?: React.ReactNode;
  collapsable?: boolean;
  Icon?:
    | React.FunctionComponent<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>>
    | React.FunctionComponent<React.PropsWithChildren<SvgIconProps>>;
  modifierClassName?: string;
  variant?: Variant;
  size?: 'small' | 'tiny';
}

export interface State {
  collapsed: boolean;
}

type Props = ICallOut;

/**
 * @deprecated Succeeded by ui/Callout (dashboard), no usage in consumer
 *
 * - [Migration Guide](https://github.com/tocktix/admin/wiki/Design-System:-Dashboard-Callout-Migration-Guide)
 * - [Storybook](http://tock-assets.tocktix.com/styleguide/dashboard/index.html?path=/story/components--callout-demo)
 */
class CallOut extends BaseComponent<Props, State> {
  state = {
    collapsed: false,
  };

  componentDidMount() {
    if (this.props.collapsable) {
      this.setState({
        collapsed: true,
      });
    }
  }

  handleToggleExpand() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const { children, collapsable, Icon } = this.props;
    const { collapsed } = this.state;

    return (
      <div className={classNameForCallOut(this.props, this.state)}>
        <div className={classNameForCallOutContent(this.props, this.state)}>
          {Icon && <Icon />}
          <div className="CallOut-contentText">{children}</div>
        </div>

        {collapsable && collapsed && (
          <div className={classNameForCallOutToggle(this.state)}>
            <LinkButton onClick={this.handleToggleExpand} variant="default">
              View
            </LinkButton>
          </div>
        )}
      </div>
    );
  }
}

export default CallOut;
